import React from "react";
import "../styles/invoiceTimeline.css";
import invoiceImg from "../assets/img/invoices/i.svg"
import invoiceImg1 from "../assets/img/invoices/i1.svg"
import invoiceImg2 from "../assets/img/invoices/i2.svg"
import { FaCheck } from "react-icons/fa6";
import { GiCheckMark } from "react-icons/gi";


const services = [
  {
    title: "Invoice Creation",
    description:
      "Easily design and send invoices with custom templates and professional branding to impress clients.",
    image: invoiceImg,
  },
  {
    title: "Payment Processing",
    description:
      "Accept secure online payments in multiple currencies and get paid faster with automated reminders.",
    image: invoiceImg1,
  },
  {
    title: "Tracking & Management",
    description:
      "Monitor invoice status in real time and stay on top of client payments with automated tracking.",
    image:invoiceImg2,
  },
];

const InvoiceTimeline = () => {
  return (
 <div className="page-wrapper">
    <div className="section-timeline-heading">
        <div className="container">
            <div className="padding-vertical-xlarge">
<div className="timeline-main_heading-wrapper">
    <div className="margin-bottom-medium">
        <h2>Smart Invoicing for Modern Businesses</h2>
    </div>
    <p className="paragraph-large">
        From creating professional invoices to tracking payments in real time, our all-in-one invoicing solution streamlines your entire billing process. 
     </p>
</div>

            </div>
        </div>
    </div>

    <div className="section-timeline">
        <div className="container">
            <div className="timeline_component">
                <div className="timeline_progress">
                    <div className="timeline_progress-bar"></div>
                </div>
{/* CREATE PROFESSIONAL INVOICE */}
<div className="timeline_item">
    <div className="timeline_left">
        <div className="timeline_date-text">Create Professional Invoice</div>
    </div>
    <div className="timeline_centre">
        <div className="timeline_circle"></div>
    </div>
    <div className="timeline-right">
        <div className="margin-bottom-xlarge">
            <div className="timeline_text">
                At Roarz Kreatives, we believe crafting professional invoices is essential for building the right brand image, earning customer trust, and encouraging timely payments. 
                Our invoice generator allows you to create perfect, branded invoices in just seconds, no design skills required.
                <ul className="space-y-2 mt-3">
                    <li className="flex items-start gap-2">
                        <GiCheckMark className="tick-icon" />
                        <p>Choose from a gallery of beautiful, ready-to-use templates</p>
                    </li>
                    <li className="flex items-start gap-2">
                        <GiCheckMark className="tick-icon" />
                        <p>Add your company logo and personalize every detail</p>
                    </li>
                    <li className="flex items-start gap-2">
                        <GiCheckMark className="tick-icon" />
                        <p>Bill clients in multiple languages for global reach</p>
                    </li>
                    <li className="flex items-start gap-2">
                        <GiCheckMark className="tick-icon" />
                        <p>Automate recurring invoices to save time</p>
                    </li>
                </ul>
            </div>
        </div>
        <div className="timeline_image-wrapper">
            <img src={invoiceImg1} alt="Invoice creation example" />
        </div>
    </div>
</div>

{/* SEND INVOICES */}
<div className="timeline_item">
    <div className="timeline_left">
        <div className="timeline_date-text">Send Invoices Effectively</div>
    </div>
    <div className="timeline_centre">
        <div className="timeline_circle"></div>
    </div>
    <div className="timeline-right">
        <div className="margin-bottom-xlarge">
            <div className="timeline_text">
                Send your invoices to clients instantly and in the most convenient way possible.
                Our platform ensures your invoices look professional and reach your customers wherever they are.
                <ul className="space-y-2 mt-3">
                    <li className="flex items-start gap-2">
                        <GiCheckMark className="tick-icon" />
                        <p>Send via SMS, email, or a secure customer portal</p>
                    </li>
                    <li className="flex items-start gap-2">
                        <GiCheckMark className="tick-icon" />
                        <p>Monitor whether invoices have been viewed or downloaded</p>
                    </li>
                    <li className="flex items-start gap-2">
                        <GiCheckMark className="tick-icon" />
                        <p>Schedule and send automated payment reminders</p>
                    </li>
                </ul>
            </div>
        </div>
        <div className="timeline_image-wrapper">
            <img src={invoiceImg1} alt="Invoice sending example" />
        </div>
    </div>
</div>

{/* PAYMENT PROCESSING */}
<div className="timeline_item">
    <div className="timeline_left">
        <div className="timeline_date-text">Payment Processing</div>
    </div>
    <div className="timeline_centre">
        <div className="timeline_circle"></div>
    </div>
    <div className="timeline-right">
        <div className="margin-bottom-xlarge">
            <div className="timeline_text">
                Get paid faster with flexible and secure payment options that make it easy for clients to settle invoices.
                <ul className="space-y-2 mt-3">
                    <li className="flex items-start gap-2">
                        <GiCheckMark className="tick-icon" />
                        <p>Enable multiple localized payment gateways</p>
                    </li>
                    <li className="flex items-start gap-2">
                        <GiCheckMark className="tick-icon" />
                        <p>Accept credit cards, ACH, direct debits, cash, or cheques</p>
                    </li>
                    <li className="flex items-start gap-2">
                        <GiCheckMark className="tick-icon" />
                        <p>Collect recurring payments automatically</p>
                    </li>
                </ul>
            </div>
        </div>
        <div className="timeline_image-wrapper">
            <img src={invoiceImg} alt="Payment processing example" />
        </div>
    </div>
</div>

{/* TRACKING & MANAGEMENT */}
<div className="timeline_item">
    <div className="timeline_left">
        <div className="timeline_date-text">Tracking & Management</div>
    </div>
    <div className="timeline_centre">
        <div className="timeline_circle"></div>
    </div>
    <div className="timeline-right">
        <div className="margin-bottom-xlarge">
            <div className="timeline_text">
                Stay on top of every invoice with real-time tracking and management tools that keep your cash flow healthy.
                <ul className="space-y-2 mt-3">
                    <li className="flex items-start gap-2">
                        <GiCheckMark className="tick-icon" />
                        <p>View payment history and outstanding balances instantly</p>
                    </li>
                    <li className="flex items-start gap-2">
                        <GiCheckMark className="tick-icon" />
                        <p>Generate detailed financial reports for smarter decisions</p>
                    </li>
                    <li className="flex items-start gap-2">
                        <GiCheckMark className="tick-icon" />
                        <p>Filter and search invoices by status, client, or date</p>
                    </li>
                    <li className="flex items-start gap-2">
                        <GiCheckMark className="tick-icon" />
                        <p>Set alerts for overdue or high-value invoices</p>
                    </li>
                </ul>
            </div>
        </div>
        <div className="timeline_image-wrapper">
            <img src={invoiceImg2} alt="Invoice tracking example" />
        </div>
    </div>
</div>


            </div>
        </div>
    </div>
</div>

  );
};

export default InvoiceTimeline;
